import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const SPECIES_ICON_OPTIONS = [
  { icon: "🐷", label: "Pig" },
  { icon: "🐔", label: "Chicken" },
  { icon: "🐄", label: "Cow" },
  { icon: "🐐", label: "Goat" },
  { icon: "🦃", label: "Turkey" },
  { icon: "🦆", label: "Duck" },
  { icon: "🐕", label: "Dog" },
  { icon: "🐈", label: "Cat" },
  { icon: "🐟", label: "Fish" },
  { icon: "🐠", label: "Tropical Fish" },
  { icon: "🐡", label: "Puffer Fish" },
  { icon: "🐇", label: "Rabbit" },
  { icon: "🐑", label: "Sheep" },
  { icon: "🐃", label: "Buffalo or Carabao" },
  { icon: "🐎", label: "Horse" },
  { icon: "🪿", label: "Goose" },
  { icon: "🦌", label: "Deer" },
  { icon: "🐝", label: "Bee" },
  { icon: "🦐", label: "Shrimp" },
  { icon: "🦀", label: "Crab" },
  { icon: "🐌", label: "Snail" },
  { icon: "🐢", label: "Turtle" },
  { icon: "🦜", label: "Bird" },
  { icon: "🐓", label: "Rooster" },
  { icon: "🥚", label: "Egg" },
  { icon: "🌾", label: "Crop or Farm" },
  { icon: "🌱", label: "Plant" },
];

export default function SpeciesIconPicker({ value, onChange, id = "species-icon" }) {
  const [open, setOpen] = useState(false);
  const selected = value || "🐾";

  return (
    <div className="space-y-2" data-testid="species-icon-picker">
      <div className="flex items-stretch gap-2">
        <button
          type="button"
          className="grid h-12 w-14 shrink-0 place-items-center rounded-md border bg-background text-3xl hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={`Current species icon ${selected}. Choose icon`}
          aria-expanded={open}
          aria-controls={`${id}-options`}
          onClick={() => setOpen((current) => !current)}
          data-testid="species-icon-current"
        >
          {selected}
        </button>
        <Input
          id={id}
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          className="h-12 min-w-0 text-center text-2xl"
          aria-label="Species icon emoji"
          placeholder="🐾"
          data-testid="species-icon-input"
        />
        <Button type="button" variant="outline" className="h-12 shrink-0" onClick={() => setOpen((current) => !current)}>
          {open ? "Close" : "Choose Icon"}
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">Choose an icon below, or type/paste any emoji.</p>
      {open && (
        <div id={`${id}-options`} className="grid max-h-56 grid-cols-5 gap-2 overflow-y-auto rounded-lg border bg-muted/20 p-2 sm:grid-cols-7" role="listbox" aria-label="Farm and animal icons">
          {SPECIES_ICON_OPTIONS.map(({ icon, label }) => (
            <button
              key={`${icon}-${label}`}
              type="button"
              role="option"
              aria-label={label}
              aria-selected={selected === icon}
              title={label}
              onClick={() => { onChange(icon); setOpen(false); }}
              className={`grid h-11 min-w-0 place-items-center rounded-md border text-2xl transition-colors hover:bg-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${selected === icon ? "border-primary bg-primary/10" : "border-border bg-background/60"}`}
              data-testid={`species-icon-option-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {icon}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
